import AdventureCourseCard from './AdventureCourseCard'
import PaperCard from './PaperCard'
import ElearningCard from './ElearningCard'
import { Fragment, useMemo } from 'react'
import propTypes from 'prop-types'

export const courseType = (trip) => {
  // Paper course card (to be displayed if following conditions are met:
  // course offered = True, course type eLearning = False (from the PADI course info table),
  // OR course offered = True, course offered as eLearning = False,
  // OR course offered = True, course offered as eLearning = True, “on PADI.com = False)
  const isElearningCardType = trip?.diveCourseInfo.isElearning

  const isElearningCard =
    !trip?.adventure &&
    trip?.isElearning &&
    trip?.onPadiCom &&
    isElearningCardType
  const isPaperCard = !trip?.adventure && !isElearningCardType
  const isPaperCard2 = !trip?.adventure && !trip?.isElearning
  const isPaperCard3 =
    !trip?.adventure && trip?.isElearning && !trip?.onPadiCom

  return { isElearningCard, isPaperCard, isPaperCard2, isPaperCard3 }
}
const CourseCardDsl = ({ trip, isWidget, wechatQr }) => {
  const {
    adventure,
    diveCourseInfo,
    activityPage,
    externalUrl,
    isBlocked,
  } = trip

  const {
    isElearningCard,
    isPaperCard,
    isPaperCard2,
    isPaperCard3,
  } = useMemo(() => courseType(trip), [trip])

  return (
    <Fragment>
      {adventure && (
        <AdventureCourseCard
          adventure={adventure}
          isHighlighted={trip.isHighlighted}
          activityPage={activityPage}
          isCourse
          isWidget={isWidget}
          isBlocked={isBlocked}
          externalPage={externalUrl}
        />
      )}
      {isElearningCard && (
        <ElearningCard
          courseInfo={diveCourseInfo}
          isHighlighted={trip.isHighlighted}
          activityPage={activityPage}
          externalPage={externalUrl}
          isCourse
          isBlocked={isBlocked}
          isWidget={isWidget}
        />
      )}
      {(isPaperCard || isPaperCard2 || isPaperCard3) && (
        <PaperCard
          adventure={diveCourseInfo}
          isHighlighted={trip.isHighlighted}
          activityPage={activityPage}
          externalPage={externalUrl}
          isWidget={isWidget}
          isBlocked={isBlocked}
          isCourse
          wechatQr={wechatQr}
        />
      )}
    </Fragment>
  )
}

export default CourseCardDsl

CourseCardDsl.propTypes = {
  trip: propTypes.shape({
    adventure: propTypes.object,
    diveCourseInfo: propTypes.object,
    activityPage: propTypes.string,
    externalUrl: propTypes.string,
    isBlocked: propTypes.bool,
    isHighlighted: propTypes.bool,
  }),
  isWidget: propTypes.bool,
  wechatQr: propTypes.string,
}
